import {
	AlignmentToolbar,
	BlockControls,
	InspectorControls,
	MediaUpload,
	PanelColorSettings,
	RichText,
	useBlockProps,
} from '@wordpress/block-editor';
import {
	BorderBoxControl,
	BoxControl,
	Button,
	ComboboxControl,
	PanelBody,
	__experimentalSpacer as Spacer,
	TextareaControl,
	ToggleControl,
} from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import './editor.scss';
const agentImage = require('./images/user.jpg');

const { SelectControl, TextControl, RangeControl } = wp.components;

const timezones = [
	{
		value: 'Africa/Abidjan',
		label: __('Africa/Abidjan', 'better-chat-support'),
	},
	{
		value: 'Africa/Accra',
		label: __('Africa/Accra', 'better-chat-support'),
	},
	{
		value: 'Africa/Addis_Ababa',
		label: __('Africa/Addis_Ababa', 'better-chat-support'),
	},
	{
		value: 'Africa/Algiers',
		label: __('Africa/Algiers', 'better-chat-support'),
	},
	{
		value: 'Africa/Asmara',
		label: __('Africa/Asmara', 'better-chat-support'),
	},
	{
		value: 'Africa/Asmera',
		label: __('Africa/Asmera', 'better-chat-support'),
	},
	{
		value: 'Africa/Bamako',
		label: __('Africa/Bamako', 'better-chat-support'),
	},
	{
		value: 'Africa/Bangui',
		label: __('Africa/Bangui', 'better-chat-support'),
	},
	{
		value: 'Africa/Banjul',
		label: __('Africa/Banjul', 'better-chat-support'),
	},
	{
		value: 'Africa/Bissau',
		label: __('Africa/Bissau', 'better-chat-support'),
	},
	{
		value: 'Africa/Blantyre',
		label: __('Africa/Blantyre', 'better-chat-support'),
	},
	{
		value: 'Africa/Brazzaville',
		label: __('Africa/Brazzaville', 'better-chat-support'),
	},
	{
		value: 'Africa/Bujumbura',
		label: __('Africa/Bujumbura', 'better-chat-support'),
	},
	{
		value: 'Africa/Cairo',
		label: __('Africa/Cairo', 'better-chat-support'),
	},
	{
		value: 'Africa/Casablanca',
		label: __('Africa/Casablanca', 'better-chat-support'),
	},
	{
		value: 'Africa/Ceuta',
		label: __('Africa/Ceuta', 'better-chat-support'),
	},
	{
		value: 'Africa/Conakry',
		label: __('Africa/Conakry', 'better-chat-support'),
	},
	{
		value: 'Africa/Dakar',
		label: __('Africa/Dakar', 'better-chat-support'),
	},
	{
		value: 'Africa/Dar_es_Salaam',
		label: __('Africa/Dar_es_Salaam', 'better-chat-support'),
	},
	{
		value: 'Africa/Djibouti',
		label: __('Africa/Djibouti', 'better-chat-support'),
	},
	{
		value: 'Africa/Douala',
		label: __('Africa/Douala', 'better-chat-support'),
	},
	{
		value: 'Africa/El_Aaiun',
		label: __('Africa/El_Aaiun', 'better-chat-support'),
	},
	{
		value: 'Africa/Freetown',
		label: __('Africa/Freetown', 'better-chat-support'),
	},
	{
		value: 'Africa/Gaborone',
		label: __('Africa/Gaborone', 'better-chat-support'),
	},
	{
		value: 'Africa/Harare',
		label: __('Africa/Harare', 'better-chat-support'),
	},
	{
		value: 'Africa/Johannesburg',
		label: __('Africa/Johannesburg', 'better-chat-support'),
	},
	{
		value: 'Africa/Juba',
		label: __('Africa/Juba', 'better-chat-support'),
	},
	{
		value: 'Africa/Kampala',
		label: __('Africa/Kampala', 'better-chat-support'),
	},
	{
		value: 'Africa/Khartoum',
		label: __('Africa/Khartoum', 'better-chat-support'),
	},
	{
		value: 'Africa/Kigali',
		label: __('Africa/Kigali', 'better-chat-support'),
	},
	{
		value: 'Africa/Kinshasa',
		label: __('Africa/Kinshasa', 'better-chat-support'),
	},
	{
		value: 'Africa/Lagos',
		label: __('Africa/Lagos', 'better-chat-support'),
	},
	{
		value: 'Africa/Libreville',
		label: __('Africa/Libreville', 'better-chat-support'),
	},
	{
		value: 'Africa/Lome',
		label: __('Africa/Lome', 'better-chat-support'),
	},
	{
		value: 'Africa/Luanda',
		label: __('Africa/Luanda', 'better-chat-support'),
	},
	{
		value: 'Africa/Lubumbashi',
		label: __('Africa/Lubumbashi', 'better-chat-support'),
	},
	{
		value: 'Africa/Lusaka',
		label: __('Africa/Lusaka', 'better-chat-support'),
	},
	{
		value: 'Africa/Malabo',
		label: __('Africa/Malabo', 'better-chat-support'),
	},
	{
		value: 'Africa/Maputo',
		label: __('Africa/Maputo', 'better-chat-support'),
	},
	{
		value: 'Africa/Maseru',
		label: __('Africa/Maseru', 'better-chat-support'),
	},
	{
		value: 'Africa/Mbabane',
		label: __('Africa/Mbabane', 'better-chat-support'),
	},
	{
		value: 'Africa/Mogadishu',
		label: __('Africa/Mogadishu', 'better-chat-support'),
	},
	{
		value: 'Africa/Monrovia',
		label: __('Africa/Monrovia', 'better-chat-support'),
	},
	{
		value: 'Africa/Nairobi',
		label: __('Africa/Nairobi', 'better-chat-support'),
	},
	{
		value: 'Africa/Ndjamena',
		label: __('Africa/Ndjamena', 'better-chat-support'),
	},
	{
		value: 'Africa/Niamey',
		label: __('Africa/Niamey', 'better-chat-support'),
	},
	{
		value: 'Africa/Nouakchott',
		label: __('Africa/Nouakchott', 'better-chat-support'),
	},
	{
		value: 'Africa/Ouagadougou',
		label: __('Africa/Ouagadougou', 'better-chat-support'),
	},
	{
		value: 'Africa/Porto-Novo',
		label: __('Africa/Porto-Novo', 'better-chat-support'),
	},
	{
		value: 'Africa/Sao_Tome',
		label: __('Africa/Sao_Tome', 'better-chat-support'),
	},
	{
		value: 'Africa/Timbuktu',
		label: __('Africa/Timbuktu', 'better-chat-support'),
	},
	{
		value: 'Africa/Tripoli',
		label: __('Africa/Tripoli', 'better-chat-support'),
	},
	{
		value: 'Africa/Tunis',
		label: __('Africa/Tunis', 'better-chat-support'),
	},
	{
		value: 'Africa/Windhoek',
		label: __('Africa/Windhoek', 'better-chat-support'),
	},
	{
		value: 'America/Adak',
		label: __('America/Adak', 'better-chat-support'),
	},
	{
		value: 'America/Anchorage',
		label: __('America/Anchorage', 'better-chat-support'),
	},
	{
		value: 'America/Anguilla',
		label: __('America/Anguilla', 'better-chat-support'),
	},
	{
		value: 'America/Antigua',
		label: __('America/Antigua', 'better-chat-support'),
	},
	{
		value: 'America/Araguaina',
		label: __('America/Araguaina', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Buenos_Aires',
		label: __('America/Argentina/Buenos_Aires', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Catamarca',
		label: __('America/Argentina/Catamarca', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/ComodRivadavia',
		label: __('America/Argentina/ComodRivadavia', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Cordoba',
		label: __('America/Argentina/Cordoba', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Jujuy',
		label: __('America/Argentina/Jujuy', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/La_Rioja',
		label: __('America/Argentina/La_Rioja', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Mendoza',
		label: __('America/Argentina/Mendoza', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Rio_Gallegos',
		label: __('America/Argentina/Rio_Gallegos', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Salta',
		label: __('America/Argentina/Salta', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/San_Juan',
		label: __('America/Argentina/San_Juan', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/San_Luis',
		label: __('America/Argentina/San_Luis', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Tucuman',
		label: __('America/Argentina/Tucuman', 'better-chat-support'),
	},
	{
		value: 'America/Argentina/Ushuaia',
		label: __('America/Argentina/Ushuaia', 'better-chat-support'),
	},
	{
		value: 'America/Aruba',
		label: __('America/Aruba', 'better-chat-support'),
	},
	{
		value: 'America/Asuncion',
		label: __('America/Asuncion', 'better-chat-support'),
	},
	{
		value: 'America/Atikokan',
		label: __('America/Atikokan', 'better-chat-support'),
	},
	{
		value: 'America/Atka',
		label: __('America/Atka', 'better-chat-support'),
	},
	{
		value: 'America/Bahia',
		label: __('America/Bahia', 'better-chat-support'),
	},
	{
		value: 'America/Bahia_Banderas',
		label: __('America/Bahia_Banderas', 'better-chat-support'),
	},
	{
		value: 'America/Barbados',
		label: __('America/Barbados', 'better-chat-support'),
	},
	{
		value: 'America/Belem',
		label: __('America/Belem', 'better-chat-support'),
	},
	{
		value: 'America/Belize',
		label: __('America/Belize', 'better-chat-support'),
	},
	{
		value: 'America/Blanc-Sablon',
		label: __('America/Blanc-Sablon', 'better-chat-support'),
	},
	{
		value: 'America/Boa_Vista',
		label: __('America/Boa_Vista', 'better-chat-support'),
	},
	{
		value: 'America/Bogota',
		label: __('America/Bogota', 'better-chat-support'),
	},
	{
		value: 'America/Boise',
		label: __('America/Boise', 'better-chat-support'),
	},
	{
		value: 'America/Buenos_Aires',
		label: __('America/Buenos_Aires', 'better-chat-support'),
	},
	{
		value: 'America/Cambridge_Bay',
		label: __('America/Cambridge_Bay', 'better-chat-support'),
	},
	{
		value: 'America/Campo_Grande',
		label: __('America/Campo_Grande', 'better-chat-support'),
	},
	{
		value: 'America/Cancun',
		label: __('America/Cancun', 'better-chat-support'),
	},
	{
		value: 'America/Caracas',
		label: __('America/Caracas', 'better-chat-support'),
	},
	{
		value: 'America/Catamarca',
		label: __('America/Catamarca', 'better-chat-support'),
	},
	{
		value: 'America/Cayenne',
		label: __('America/Cayenne', 'better-chat-support'),
	},
	{
		value: 'America/Cayman',
		label: __('America/Cayman', 'better-chat-support'),
	},
	{
		value: 'America/Chicago',
		label: __('America/Chicago', 'better-chat-support'),
	},
	{
		value: 'America/Chihuahua',
		label: __('America/Chihuahua', 'better-chat-support'),
	},
	{
		value: 'America/Coral_Harbour',
		label: __('America/Coral_Harbour', 'better-chat-support'),
	},
	{
		value: 'America/Cordoba',
		label: __('America/Cordoba', 'better-chat-support'),
	},
	{
		value: 'America/Costa_Rica',
		label: __('America/Costa_Rica', 'better-chat-support'),
	},
	{
		value: 'America/Creston',
		label: __('America/Creston', 'better-chat-support'),
	},
	{
		value: 'America/Cuiaba',
		label: __('America/Cuiaba', 'better-chat-support'),
	},
	{
		value: 'America/Curacao',
		label: __('America/Curacao', 'better-chat-support'),
	},
	{
		value: 'America/Danmarkshavn',
		label: __('America/Danmarkshavn', 'better-chat-support'),
	},
	{
		value: 'America/Dawson',
		label: __('America/Dawson', 'better-chat-support'),
	},
	{
		value: 'America/Dawson_Creek',
		label: __('America/Dawson_Creek', 'better-chat-support'),
	},
	{
		value: 'America/Denver',
		label: __('America/Denver', 'better-chat-support'),
	},
	{
		value: 'America/Detroit',
		label: __('America/Detroit', 'better-chat-support'),
	},
	{
		value: 'America/Dominica',
		label: __('America/Dominica', 'better-chat-support'),
	},
	{
		value: 'America/Edmonton',
		label: __('America/Edmonton', 'better-chat-support'),
	},
	{
		value: 'America/Eirunepe',
		label: __('America/Eirunepe', 'better-chat-support'),
	},
	{
		value: 'America/El_Salvador',
		label: __('America/El_Salvador', 'better-chat-support'),
	},
	{
		value: 'America/Ensenada',
		label: __('America/Ensenada', 'better-chat-support'),
	},
	{
		value: 'America/Fort_Nelson',
		label: __('America/Fort_Nelson', 'better-chat-support'),
	},
	{
		value: 'America/Fort_Wayne',
		label: __('America/Fort_Wayne', 'better-chat-support'),
	},
	{
		value: 'America/Fortaleza',
		label: __('America/Fortaleza', 'better-chat-support'),
	},
	{
		value: 'America/Glace_Bay',
		label: __('America/Glace_Bay', 'better-chat-support'),
	},
	{
		value: 'America/Godthab',
		label: __('America/Godthab', 'better-chat-support'),
	},
	{
		value: 'America/Goose_Bay',
		label: __('America/Goose_Bay', 'better-chat-support'),
	},
	{
		value: 'America/Grand_Turk',
		label: __('America/Grand_Turk', 'better-chat-support'),
	},
	{
		value: 'America/Grenada',
		label: __('America/Grenada', 'better-chat-support'),
	},
	{
		value: 'America/Guadeloupe',
		label: __('America/Guadeloupe', 'better-chat-support'),
	},
	{
		value: 'America/Guatemala',
		label: __('America/Guatemala', 'better-chat-support'),
	},
	{
		value: 'America/Guayaquil',
		label: __('America/Guayaquil', 'better-chat-support'),
	},
	{
		value: 'America/Guyana',
		label: __('America/Guyana', 'better-chat-support'),
	},
	{
		value: 'America/Halifax',
		label: __('America/Halifax', 'better-chat-support'),
	},
	{
		value: 'America/Havana',
		label: __('America/Havana', 'better-chat-support'),
	},
	{
		value: 'America/Hermosillo',
		label: __('America/Hermosillo', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Indianapolis',
		label: __('America/Indiana/Indianapolis', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Knox',
		label: __('America/Indiana/Knox', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Marengo',
		label: __('America/Indiana/Marengo', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Petersburg',
		label: __('America/Indiana/Petersburg', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Tell_City',
		label: __('America/Indiana/Tell_City', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Vevay',
		label: __('America/Indiana/Vevay', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Vincennes',
		label: __('America/Indiana/Vincennes', 'better-chat-support'),
	},
	{
		value: 'America/Indiana/Winamac',
		label: __('America/Indiana/Winamac', 'better-chat-support'),
	},
	{
		value: 'America/Indianapolis',
		label: __('America/Indianapolis', 'better-chat-support'),
	},
	{
		value: 'America/Inuvik',
		label: __('America/Inuvik', 'better-chat-support'),
	},
	{
		value: 'America/Iqaluit',
		label: __('America/Iqaluit', 'better-chat-support'),
	},
	{
		value: 'America/Jamaica',
		label: __('America/Jamaica', 'better-chat-support'),
	},
	{
		value: 'America/Jujuy',
		label: __('America/Jujuy', 'better-chat-support'),
	},
	{
		value: 'America/Juneau',
		label: __('America/Juneau', 'better-chat-support'),
	},
	{
		value: 'America/Kentucky/Louisville',
		label: __('America/Kentucky/Louisville', 'better-chat-support'),
	},
	{
		value: 'America/Kentucky/Monticello',
		label: __('America/Kentucky/Monticello', 'better-chat-support'),
	},
	{
		value: 'America/Knox_IN',
		label: __('America/Knox_IN', 'better-chat-support'),
	},
	{
		value: 'America/Kralendijk',
		label: __('America/Kralendijk', 'better-chat-support'),
	},
	{
		value: 'America/La_Paz',
		label: __('America/La_Paz', 'better-chat-support'),
	},
	{
		value: 'America/Lima',
		label: __('America/Lima', 'better-chat-support'),
	},
	{
		value: 'America/Los_Angeles',
		label: __('America/Los_Angeles', 'better-chat-support'),
	},
	{
		value: 'America/Louisville',
		label: __('America/Louisville', 'better-chat-support'),
	},
	{
		value: 'America/Lower_Princes',
		label: __('America/Lower_Princes', 'better-chat-support'),
	},
	{
		value: 'America/Maceio',
		label: __('America/Maceio', 'better-chat-support'),
	},
	{
		value: 'America/Managua',
		label: __('America/Managua', 'better-chat-support'),
	},
	{
		value: 'America/Manaus',
		label: __('America/Manaus', 'better-chat-support'),
	},
	{
		value: 'America/Marigot',
		label: __('America/Marigot', 'better-chat-support'),
	},
	{
		value: 'America/Martinique',
		label: __('America/Martinique', 'better-chat-support'),
	},
	{
		value: 'America/Matamoros',
		label: __('America/Matamoros', 'better-chat-support'),
	},
	{
		value: 'America/Mazatlan',
		label: __('America/Mazatlan', 'better-chat-support'),
	},
	{
		value: 'America/Mendoza',
		label: __('America/Mendoza', 'better-chat-support'),
	},
	{
		value: 'America/Menominee',
		label: __('America/Menominee', 'better-chat-support'),
	},
	{
		value: 'America/Merida',
		label: __('America/Merida', 'better-chat-support'),
	},
	{
		value: 'America/Metlakatla',
		label: __('America/Metlakatla', 'better-chat-support'),
	},
	{
		value: 'America/Mexico_City',
		label: __('America/Mexico_City', 'better-chat-support'),
	},
	{
		value: 'America/Miquelon',
		label: __('America/Miquelon', 'better-chat-support'),
	},
	{
		value: 'America/Moncton',
		label: __('America/Moncton', 'better-chat-support'),
	},
	{
		value: 'America/Monterrey',
		label: __('America/Monterrey', 'better-chat-support'),
	},
	{
		value: 'America/Montevideo',
		label: __('America/Montevideo', 'better-chat-support'),
	},
	{
		value: 'America/Montreal',
		label: __('America/Montreal', 'better-chat-support'),
	},
	{
		value: 'America/Montserrat',
		label: __('America/Montserrat', 'better-chat-support'),
	},
	{
		value: 'America/Nassau',
		label: __('America/Nassau', 'better-chat-support'),
	},
	{
		value: 'America/New_York',
		label: __('America/New_York', 'better-chat-support'),
	},
	{
		value: 'America/Nipigon',
		label: __('America/Nipigon', 'better-chat-support'),
	},
	{
		value: 'America/Nome',
		label: __('America/Nome', 'better-chat-support'),
	},
	{
		value: 'America/Noronha',
		label: __('America/Noronha', 'better-chat-support'),
	},
	{
		value: 'America/North_Dakota/Beulah',
		label: __('America/North_Dakota/Beulah', 'better-chat-support'),
	},
	{
		value: 'America/North_Dakota/Center',
		label: __('America/North_Dakota/Center', 'better-chat-support'),
	},
	{
		value: 'America/North_Dakota/New_Salem',
		label: __('America/North_Dakota/New_Salem', 'better-chat-support'),
	},
	{
		value: 'America/Ojinaga',
		label: __('America/Ojinaga', 'better-chat-support'),
	},
	{
		value: 'America/Panama',
		label: __('America/Panama', 'better-chat-support'),
	},
	{
		value: 'America/Pangnirtung',
		label: __('America/Pangnirtung', 'better-chat-support'),
	},
	{
		value: 'America/Paramaribo',
		label: __('America/Paramaribo', 'better-chat-support'),
	},
	{
		value: 'America/Phoenix',
		label: __('America/Phoenix', 'better-chat-support'),
	},
	{
		value: 'America/Port-au-Prince',
		label: __('America/Port-au-Prince', 'better-chat-support'),
	},
	{
		value: 'America/Port_of_Spain',
		label: __('America/Port_of_Spain', 'better-chat-support'),
	},
	{
		value: 'America/Porto_Acre',
		label: __('America/Porto_Acre', 'better-chat-support'),
	},
	{
		value: 'America/Porto_Velho',
		label: __('America/Porto_Velho', 'better-chat-support'),
	},
	{
		value: 'America/Puerto_Rico',
		label: __('America/Puerto_Rico', 'better-chat-support'),
	},
	{
		value: 'America/Punta_Arenas',
		label: __('America/Punta_Arenas', 'better-chat-support'),
	},
	{
		value: 'America/Rainy_River',
		label: __('America/Rainy_River', 'better-chat-support'),
	},
	{
		value: 'America/Rankin_Inlet',
		label: __('America/Rankin_Inlet', 'better-chat-support'),
	},
	{
		value: 'America/Recife',
		label: __('America/Recife', 'better-chat-support'),
	},
	{
		value: 'America/Regina',
		label: __('America/Regina', 'better-chat-support'),
	},
	{
		value: 'America/Resolute',
		label: __('America/Resolute', 'better-chat-support'),
	},
	{
		value: 'America/Rio_Branco',
		label: __('America/Rio_Branco', 'better-chat-support'),
	},
	{
		value: 'America/Rosario',
		label: __('America/Rosario', 'better-chat-support'),
	},
	{
		value: 'America/Santa_Isabel',
		label: __('America/Santa_Isabel', 'better-chat-support'),
	},
	{
		value: 'America/Santarem',
		label: __('America/Santarem', 'better-chat-support'),
	},
	{
		value: 'America/Santiago',
		label: __('America/Santiago', 'better-chat-support'),
	},
	{
		value: 'America/Santo_Domingo',
		label: __('America/Santo_Domingo', 'better-chat-support'),
	},
	{
		value: 'America/Sao_Paulo',
		label: __('America/Sao_Paulo', 'better-chat-support'),
	},
	{
		value: 'America/Scoresbysund',
		label: __('America/Scoresbysund', 'better-chat-support'),
	},
	{
		value: 'America/Shiprock',
		label: __('America/Shiprock', 'better-chat-support'),
	},
	{
		value: 'America/Sitka',
		label: __('America/Sitka', 'better-chat-support'),
	},
	{
		value: 'America/St_Barthelemy',
		label: __('America/St_Barthelemy', 'better-chat-support'),
	},
	{
		value: 'America/St_Johns',
		label: __('America/St_Johns', 'better-chat-support'),
	},
	{
		value: 'America/St_Kitts',
		label: __('America/St_Kitts', 'better-chat-support'),
	},
	{
		value: 'America/St_Lucia',
		label: __('America/St_Lucia', 'better-chat-support'),
	},
	{
		value: 'America/St_Thomas',
		label: __('America/St_Thomas', 'better-chat-support'),
	},
	{
		value: 'America/St_Vincent',
		label: __('America/St_Vincent', 'better-chat-support'),
	},
	{
		value: 'America/Swift_Current',
		label: __('America/Swift_Current', 'better-chat-support'),
	},
	{
		value: 'America/Tegucigalpa',
		label: __('America/Tegucigalpa', 'better-chat-support'),
	},
	{
		value: 'America/Thule',
		label: __('America/Thule', 'better-chat-support'),
	},
	{
		value: 'America/Thunder_Bay',
		label: __('America/Thunder_Bay', 'better-chat-support'),
	},
	{
		value: 'America/Tijuana',
		label: __('America/Tijuana', 'better-chat-support'),
	},
	{
		value: 'America/Toronto',
		label: __('America/Toronto', 'better-chat-support'),
	},
	{
		value: 'America/Tortola',
		label: __('America/Tortola', 'better-chat-support'),
	},
	{
		value: 'America/Vancouver',
		label: __('America/Vancouver', 'better-chat-support'),
	},
	{
		value: 'America/Virgin',
		label: __('America/Virgin', 'better-chat-support'),
	},
	{
		value: 'America/Whitehorse',
		label: __('America/Whitehorse', 'better-chat-support'),
	},
	{
		value: 'America/Winnipeg',
		label: __('America/Winnipeg', 'better-chat-support'),
	},
	{
		value: 'America/Yakutat',
		label: __('America/Yakutat', 'better-chat-support'),
	},
	{
		value: 'America/Yellowknife',
		label: __('America/Yellowknife', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Casey',
		label: __('Antarctica/Casey', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Davis',
		label: __('Antarctica/Davis', 'better-chat-support'),
	},
	{
		value: 'Antarctica/DumontDUrville',
		label: __('Antarctica/DumontDUrville', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Macquarie',
		label: __('Antarctica/Macquarie', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Mawson',
		label: __('Antarctica/Mawson', 'better-chat-support'),
	},
	{
		value: 'Antarctica/McMurdo',
		label: __('Antarctica/McMurdo', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Palmer',
		label: __('Antarctica/Palmer', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Rothera',
		label: __('Antarctica/Rothera', 'better-chat-support'),
	},
	{
		value: 'Antarctica/South_Pole',
		label: __('Antarctica/South_Pole', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Syowa',
		label: __('Antarctica/Syowa', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Troll',
		label: __('Antarctica/Troll', 'better-chat-support'),
	},
	{
		value: 'Antarctica/Vostok',
		label: __('Antarctica/Vostok', 'better-chat-support'),
	},
	{
		value: 'Arctic/Longyearbyen',
		label: __('Arctic/Longyearbyen', 'better-chat-support'),
	},
	{
		value: 'Asia/Aden',
		label: __('Asia/Aden', 'better-chat-support'),
	},
	{
		value: 'Asia/Almaty',
		label: __('Asia/Almaty', 'better-chat-support'),
	},
	{
		value: 'Asia/Amman',
		label: __('Asia/Amman', 'better-chat-support'),
	},
	{
		value: 'Asia/Anadyr',
		label: __('Asia/Anadyr', 'better-chat-support'),
	},
	{
		value: 'Asia/Aqtau',
		label: __('Asia/Aqtau', 'better-chat-support'),
	},
	{
		value: 'Asia/Aqtobe',
		label: __('Asia/Aqtobe', 'better-chat-support'),
	},
	{
		value: 'Asia/Ashgabat',
		label: __('Asia/Ashgabat', 'better-chat-support'),
	},
	{
		value: 'Asia/Ashkhabad',
		label: __('Asia/Ashkhabad', 'better-chat-support'),
	},
	{
		value: 'Asia/Atyrau',
		label: __('Asia/Atyrau', 'better-chat-support'),
	},
	{
		value: 'Asia/Baghdad',
		label: __('Asia/Baghdad', 'better-chat-support'),
	},
	{
		value: 'Asia/Bahrain',
		label: __('Asia/Bahrain', 'better-chat-support'),
	},
	{
		value: 'Asia/Baku',
		label: __('Asia/Baku', 'better-chat-support'),
	},
	{
		value: 'Asia/Bangkok',
		label: __('Asia/Bangkok', 'better-chat-support'),
	},
	{
		value: 'Asia/Barnaul',
		label: __('Asia/Barnaul', 'better-chat-support'),
	},
	{
		value: 'Asia/Beirut',
		label: __('Asia/Beirut', 'better-chat-support'),
	},
	{
		value: 'Asia/Bishkek',
		label: __('Asia/Bishkek', 'better-chat-support'),
	},
	{
		value: 'Asia/Brunei',
		label: __('Asia/Brunei', 'better-chat-support'),
	},
	{
		value: 'Asia/Calcutta',
		label: __('Asia/Calcutta', 'better-chat-support'),
	},
	{
		value: 'Asia/Chita',
		label: __('Asia/Chita', 'better-chat-support'),
	},
	{
		value: 'Asia/Choibalsan',
		label: __('Asia/Choibalsan', 'better-chat-support'),
	},
	{
		value: 'Asia/Chongqing',
		label: __('Asia/Chongqing', 'better-chat-support'),
	},
	{
		value: 'Asia/Chungking',
		label: __('Asia/Chungking', 'better-chat-support'),
	},
	{
		value: 'Asia/Colombo',
		label: __('Asia/Colombo', 'better-chat-support'),
	},
	{
		value: 'Asia/Dacca',
		label: __('Asia/Dacca', 'better-chat-support'),
	},
	{
		value: 'Asia/Damascus',
		label: __('Asia/Damascus', 'better-chat-support'),
	},
	{
		value: 'Asia/Dhaka',
		label: __('Asia/Dhaka', 'better-chat-support'),
	},
	{
		value: 'Asia/Dili',
		label: __('Asia/Dili', 'better-chat-support'),
	},
	{
		value: 'Asia/Dubai',
		label: __('Asia/Dubai', 'better-chat-support'),
	},
	{
		value: 'Asia/Dushanbe',
		label: __('Asia/Dushanbe', 'better-chat-support'),
	},
	{
		value: 'Asia/Famagusta',
		label: __('Asia/Famagusta', 'better-chat-support'),
	},
	{
		value: 'Asia/Gaza',
		label: __('Asia/Gaza', 'better-chat-support'),
	},
	{
		value: 'Asia/Harbin',
		label: __('Asia/Harbin', 'better-chat-support'),
	},
	{
		value: 'Asia/Hebron',
		label: __('Asia/Hebron', 'better-chat-support'),
	},
	{
		value: 'Asia/Ho_Chi_Minh',
		label: __('Asia/Ho_Chi_Minh', 'better-chat-support'),
	},
	{
		value: 'Asia/Hong_Kong',
		label: __('Asia/Hong_Kong', 'better-chat-support'),
	},
	{
		value: 'Asia/Hovd',
		label: __('Asia/Hovd', 'better-chat-support'),
	},
	{
		value: 'Asia/Irkutsk',
		label: __('Asia/Irkutsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Istanbul',
		label: __('Asia/Istanbul', 'better-chat-support'),
	},
	{
		value: 'Asia/Jakarta',
		label: __('Asia/Jakarta', 'better-chat-support'),
	},
	{
		value: 'Asia/Jayapura',
		label: __('Asia/Jayapura', 'better-chat-support'),
	},
	{
		value: 'Asia/Jerusalem',
		label: __('Asia/Jerusalem', 'better-chat-support'),
	},
	{
		value: 'Asia/Kabul',
		label: __('Asia/Kabul', 'better-chat-support'),
	},
	{
		value: 'Asia/Kamchatka',
		label: __('Asia/Kamchatka', 'better-chat-support'),
	},
	{
		value: 'Asia/Karachi',
		label: __('Asia/Karachi', 'better-chat-support'),
	},
	{
		value: 'Asia/Kashgar',
		label: __('Asia/Kashgar', 'better-chat-support'),
	},
	{
		value: 'Asia/Kathmandu',
		label: __('Asia/Kathmandu', 'better-chat-support'),
	},
	{
		value: 'Asia/Katmandu',
		label: __('Asia/Katmandu', 'better-chat-support'),
	},
	{
		value: 'Asia/Khandyga',
		label: __('Asia/Khandyga', 'better-chat-support'),
	},
	{
		value: 'Asia/Kolkata',
		label: __('Asia/Kolkata', 'better-chat-support'),
	},
	{
		value: 'Asia/Krasnoyarsk',
		label: __('Asia/Krasnoyarsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Kuala_Lumpur',
		label: __('Asia/Kuala_Lumpur', 'better-chat-support'),
	},
	{
		value: 'Asia/Kuching',
		label: __('Asia/Kuching', 'better-chat-support'),
	},
	{
		value: 'Asia/Kuwait',
		label: __('Asia/Kuwait', 'better-chat-support'),
	},
	{
		value: 'Asia/Macao',
		label: __('Asia/Macao', 'better-chat-support'),
	},
	{
		value: 'Asia/Macau',
		label: __('Asia/Macau', 'better-chat-support'),
	},
	{
		value: 'Asia/Magadan',
		label: __('Asia/Magadan', 'better-chat-support'),
	},
	{
		value: 'Asia/Makassar',
		label: __('Asia/Makassar', 'better-chat-support'),
	},
	{
		value: 'Asia/Manila',
		label: __('Asia/Manila', 'better-chat-support'),
	},
	{
		value: 'Asia/Muscat',
		label: __('Asia/Muscat', 'better-chat-support'),
	},
	{
		value: 'Asia/Nicosia',
		label: __('Asia/Nicosia', 'better-chat-support'),
	},
	{
		value: 'Asia/Novokuznetsk',
		label: __('Asia/Novokuznetsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Novosibirsk',
		label: __('Asia/Novosibirsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Omsk',
		label: __('Asia/Omsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Oral',
		label: __('Asia/Oral', 'better-chat-support'),
	},
	{
		value: 'Asia/Phnom_Penh',
		label: __('Asia/Phnom_Penh', 'better-chat-support'),
	},
	{
		value: 'Asia/Pontianak',
		label: __('Asia/Pontianak', 'better-chat-support'),
	},
	{
		value: 'Asia/Pyongyang',
		label: __('Asia/Pyongyang', 'better-chat-support'),
	},
	{
		value: 'Asia/Qatar',
		label: __('Asia/Qatar', 'better-chat-support'),
	},
	{
		value: 'Asia/Qyzylorda',
		label: __('Asia/Qyzylorda', 'better-chat-support'),
	},
	{
		value: 'Asia/Rangoon',
		label: __('Asia/Rangoon', 'better-chat-support'),
	},
	{
		value: 'Asia/Riyadh',
		label: __('Asia/Riyadh', 'better-chat-support'),
	},
	{
		value: 'Asia/Saigon',
		label: __('Asia/Saigon', 'better-chat-support'),
	},
	{
		value: 'Asia/Sakhalin',
		label: __('Asia/Sakhalin', 'better-chat-support'),
	},
	{
		value: 'Asia/Samarkand',
		label: __('Asia/Samarkand', 'better-chat-support'),
	},
	{
		value: 'Asia/Seoul',
		label: __('Asia/Seoul', 'better-chat-support'),
	},
	{
		value: 'Asia/Shanghai',
		label: __('Asia/Shanghai', 'better-chat-support'),
	},
	{
		value: 'Asia/Singapore',
		label: __('Asia/Singapore', 'better-chat-support'),
	},
	{
		value: 'Asia/Srednekolymsk',
		label: __('Asia/Srednekolymsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Taipei',
		label: __('Asia/Taipei', 'better-chat-support'),
	},
	{
		value: 'Asia/Tashkent',
		label: __('Asia/Tashkent', 'better-chat-support'),
	},
	{
		value: 'Asia/Tbilisi',
		label: __('Asia/Tbilisi', 'better-chat-support'),
	},
	{
		value: 'Asia/Tehran',
		label: __('Asia/Tehran', 'better-chat-support'),
	},
	{
		value: 'Asia/Tel_Aviv',
		label: __('Asia/Tel_Aviv', 'better-chat-support'),
	},
	{
		value: 'Asia/Thimbu',
		label: __('Asia/Thimbu', 'better-chat-support'),
	},
	{
		value: 'Asia/Thimphu',
		label: __('Asia/Thimphu', 'better-chat-support'),
	},
	{
		value: 'Asia/Tokyo',
		label: __('Asia/Tokyo', 'better-chat-support'),
	},
	{
		value: 'Asia/Tomsk',
		label: __('Asia/Tomsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Ujung_Pandang',
		label: __('Asia/Ujung_Pandang', 'better-chat-support'),
	},
	{
		value: 'Asia/Ulaanbaatar',
		label: __('Asia/Ulaanbaatar', 'better-chat-support'),
	},
	{
		value: 'Asia/Ulan_Bator',
		label: __('Asia/Ulan_Bator', 'better-chat-support'),
	},
	{
		value: 'Asia/Urumqi',
		label: __('Asia/Urumqi', 'better-chat-support'),
	},
	{
		value: 'Asia/Ust-Nera',
		label: __('Asia/Ust-Nera', 'better-chat-support'),
	},
	{
		value: 'Asia/Vientiane',
		label: __('Asia/Vientiane', 'better-chat-support'),
	},
	{
		value: 'Asia/Vladivostok',
		label: __('Asia/Vladivostok', 'better-chat-support'),
	},
	{
		value: 'Asia/Yakutsk',
		label: __('Asia/Yakutsk', 'better-chat-support'),
	},
	{
		value: 'Asia/Yangon',
		label: __('Asia/Yangon', 'better-chat-support'),
	},
	{
		value: 'Asia/Yekaterinburg',
		label: __('Asia/Yekaterinburg', 'better-chat-support'),
	},
	{
		value: 'Asia/Yerevan',
		label: __('Asia/Yerevan', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Azores',
		label: __('Atlantic/Azores', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Bermuda',
		label: __('Atlantic/Bermuda', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Canary',
		label: __('Atlantic/Canary', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Cape_Verde',
		label: __('Atlantic/Cape_Verde', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Faeroe',
		label: __('Atlantic/Faeroe', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Faroe',
		label: __('Atlantic/Faroe', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Jan_Mayen',
		label: __('Atlantic/Jan_Mayen', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Madeira',
		label: __('Atlantic/Madeira', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Reykjavik',
		label: __('Atlantic/Reykjavik', 'better-chat-support'),
	},
	{
		value: 'Atlantic/South_Georgia',
		label: __('Atlantic/South_Georgia', 'better-chat-support'),
	},
	{
		value: 'Atlantic/St_Helena',
		label: __('Atlantic/St_Helena', 'better-chat-support'),
	},
	{
		value: 'Atlantic/Stanley',
		label: __('Atlantic/Stanley', 'better-chat-support'),
	},
	{
		value: 'Australia/ACT',
		label: __('Australia/ACT', 'better-chat-support'),
	},
	{
		value: 'Australia/Adelaide',
		label: __('Australia/Adelaide', 'better-chat-support'),
	},
	{
		value: 'Australia/Brisbane',
		label: __('Australia/Brisbane', 'better-chat-support'),
	},
	{
		value: 'Australia/Broken_Hill',
		label: __('Australia/Broken_Hill', 'better-chat-support'),
	},
	{
		value: 'Australia/Canberra',
		label: __('Australia/Canberra', 'better-chat-support'),
	},
	{
		value: 'Australia/Currie',
		label: __('Australia/Currie', 'better-chat-support'),
	},
	{
		value: 'Australia/Darwin',
		label: __('Australia/Darwin', 'better-chat-support'),
	},
	{
		value: 'Australia/Eucla',
		label: __('Australia/Eucla', 'better-chat-support'),
	},
	{
		value: 'Australia/Hobart',
		label: __('Australia/Hobart', 'better-chat-support'),
	},
	{
		value: 'Australia/LHI',
		label: __('Australia/LHI', 'better-chat-support'),
	},
	{
		value: 'Australia/Lindeman',
		label: __('Australia/Lindeman', 'better-chat-support'),
	},
	{
		value: 'Australia/Lord_Howe',
		label: __('Australia/Lord_Howe', 'better-chat-support'),
	},
	{
		value: 'Australia/Melbourne',
		label: __('Australia/Melbourne', 'better-chat-support'),
	},
	{
		value: 'Australia/NSW',
		label: __('Australia/NSW', 'better-chat-support'),
	},
	{
		value: 'Australia/North',
		label: __('Australia/North', 'better-chat-support'),
	},
	{
		value: 'Australia/Perth',
		label: __('Australia/Perth', 'better-chat-support'),
	},
	{
		value: 'Australia/Queensland',
		label: __('Australia/Queensland', 'better-chat-support'),
	},
	{
		value: 'Australia/South',
		label: __('Australia/South', 'better-chat-support'),
	},
	{
		value: 'Australia/Sydney',
		label: __('Australia/Sydney', 'better-chat-support'),
	},
	{
		value: 'Australia/Tasmania',
		label: __('Australia/Tasmania', 'better-chat-support'),
	},
	{
		value: 'Australia/Victoria',
		label: __('Australia/Victoria', 'better-chat-support'),
	},
	{
		value: 'Australia/West',
		label: __('Australia/West', 'better-chat-support'),
	},
	{
		value: 'Australia/Yancowinna',
		label: __('Australia/Yancowinna', 'better-chat-support'),
	},
	{
		value: 'Brazil/Acre',
		label: __('Brazil/Acre', 'better-chat-support'),
	},
	{
		value: 'Brazil/DeNoronha',
		label: __('Brazil/DeNoronha', 'better-chat-support'),
	},
	{
		value: 'Brazil/East',
		label: __('Brazil/East', 'better-chat-support'),
	},
	{
		value: 'Brazil/West',
		label: __('Brazil/West', 'better-chat-support'),
	},
	{
		value: 'CET',
		label: __('CET', 'better-chat-support'),
	},
	{
		value: 'CST6CDT',
		label: __('CST6CDT', 'better-chat-support'),
	},
	{
		value: 'Canada/Atlantic',
		label: __('Canada/Atlantic', 'better-chat-support'),
	},
	{
		value: 'Canada/Central',
		label: __('Canada/Central', 'better-chat-support'),
	},
	{
		value: 'Canada/Eastern',
		label: __('Canada/Eastern', 'better-chat-support'),
	},
	{
		value: 'Canada/Mountain',
		label: __('Canada/Mountain', 'better-chat-support'),
	},
	{
		value: 'Canada/Newfoundland',
		label: __('Canada/Newfoundland', 'better-chat-support'),
	},
	{
		value: 'Canada/Pacific',
		label: __('Canada/Pacific', 'better-chat-support'),
	},
	{
		value: 'Canada/Saskatchewan',
		label: __('Canada/Saskatchewan', 'better-chat-support'),
	},
	{
		value: 'Canada/Yukon',
		label: __('Canada/Yukon', 'better-chat-support'),
	},
	{
		value: 'Chile/Continental',
		label: __('Chile/Continental', 'better-chat-support'),
	},
	{
		value: 'Chile/EasterIsland',
		label: __('Chile/EasterIsland', 'better-chat-support'),
	},
	{
		value: 'Cuba',
		label: __('Cuba', 'better-chat-support'),
	},
	{
		value: 'EET',
		label: __('EET', 'better-chat-support'),
	},
	{
		value: 'EST',
		label: __('EST', 'better-chat-support'),
	},
	{
		value: 'EST5EDT',
		label: __('EST5EDT', 'better-chat-support'),
	},
	{
		value: 'Egypt',
		label: __('Egypt', 'better-chat-support'),
	},
	{
		value: 'Eire',
		label: __('Eire', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT',
		label: __('Etc/GMT', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+0',
		label: __('Etc/GMT+0', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+1',
		label: __('Etc/GMT+1', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+10',
		label: __('Etc/GMT+10', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+11',
		label: __('Etc/GMT+11', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+12',
		label: __('Etc/GMT+12', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+2',
		label: __('Etc/GMT+2', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+3',
		label: __('Etc/GMT+3', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+4',
		label: __('Etc/GMT+4', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+5',
		label: __('Etc/GMT+5', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+6',
		label: __('Etc/GMT+6', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+7',
		label: __('Etc/GMT+7', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+8',
		label: __('Etc/GMT+8', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT+9',
		label: __('Etc/GMT+9', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-0',
		label: __('Etc/GMT-0', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-1',
		label: __('Etc/GMT-1', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-10',
		label: __('Etc/GMT-10', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-11',
		label: __('Etc/GMT-11', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-12',
		label: __('Etc/GMT-12', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-13',
		label: __('Etc/GMT-13', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-14',
		label: __('Etc/GMT-14', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-2',
		label: __('Etc/GMT-2', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-3',
		label: __('Etc/GMT-3', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-4',
		label: __('Etc/GMT-4', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-5',
		label: __('Etc/GMT-5', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-6',
		label: __('Etc/GMT-6', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-7',
		label: __('Etc/GMT-7', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-8',
		label: __('Etc/GMT-8', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT-9',
		label: __('Etc/GMT-9', 'better-chat-support'),
	},
	{
		value: 'Etc/GMT0',
		label: __('Etc/GMT0', 'better-chat-support'),
	},
	{
		value: 'Etc/Greenwich',
		label: __('Etc/Greenwich', 'better-chat-support'),
	},
	{
		value: 'Etc/UCT',
		label: __('Etc/UCT', 'better-chat-support'),
	},
	{
		value: 'Etc/UTC',
		label: __('Etc/UTC', 'better-chat-support'),
	},
	{
		value: 'Etc/Universal',
		label: __('Etc/Universal', 'better-chat-support'),
	},
	{
		value: 'Etc/Zulu',
		label: __('Etc/Zulu', 'better-chat-support'),
	},
	{
		value: 'Europe/Amsterdam',
		label: __('Europe/Amsterdam', 'better-chat-support'),
	},
	{
		value: 'Europe/Andorra',
		label: __('Europe/Andorra', 'better-chat-support'),
	},
	{
		value: 'Europe/Astrakhan',
		label: __('Europe/Astrakhan', 'better-chat-support'),
	},
	{
		value: 'Europe/Athens',
		label: __('Europe/Athens', 'better-chat-support'),
	},
	{
		value: 'Europe/Belfast',
		label: __('Europe/Belfast', 'better-chat-support'),
	},
	{
		value: 'Europe/Belgrade',
		label: __('Europe/Belgrade', 'better-chat-support'),
	},
	{
		value: 'Europe/Berlin',
		label: __('Europe/Berlin', 'better-chat-support'),
	},
	{
		value: 'Europe/Bratislava',
		label: __('Europe/Bratislava', 'better-chat-support'),
	},
	{
		value: 'Europe/Brussels',
		label: __('Europe/Brussels', 'better-chat-support'),
	},
	{
		value: 'Europe/Bucharest',
		label: __('Europe/Bucharest', 'better-chat-support'),
	},
	{
		value: 'Europe/Budapest',
		label: __('Europe/Budapest', 'better-chat-support'),
	},
	{
		value: 'Europe/Busingen',
		label: __('Europe/Busingen', 'better-chat-support'),
	},
	{
		value: 'Europe/Chisinau',
		label: __('Europe/Chisinau', 'better-chat-support'),
	},
	{
		value: 'Europe/Copenhagen',
		label: __('Europe/Copenhagen', 'better-chat-support'),
	},
	{
		value: 'Europe/Dublin',
		label: __('Europe/Dublin', 'better-chat-support'),
	},
	{
		value: 'Europe/Gibraltar',
		label: __('Europe/Gibraltar', 'better-chat-support'),
	},
	{
		value: 'Europe/Guernsey',
		label: __('Europe/Guernsey', 'better-chat-support'),
	},
	{
		value: 'Europe/Helsinki',
		label: __('Europe/Helsinki', 'better-chat-support'),
	},
	{
		value: 'Europe/Isle_of_Man',
		label: __('Europe/Isle_of_Man', 'better-chat-support'),
	},
	{
		value: 'Europe/Istanbul',
		label: __('Europe/Istanbul', 'better-chat-support'),
	},
	{
		value: 'Europe/Jersey',
		label: __('Europe/Jersey', 'better-chat-support'),
	},
	{
		value: 'Europe/Kaliningrad',
		label: __('Europe/Kaliningrad', 'better-chat-support'),
	},
	{
		value: 'Europe/Kiev',
		label: __('Europe/Kiev', 'better-chat-support'),
	},
	{
		value: 'Europe/Kirov',
		label: __('Europe/Kirov', 'better-chat-support'),
	},
	{
		value: 'Europe/Lisbon',
		label: __('Europe/Lisbon', 'better-chat-support'),
	},
	{
		value: 'Europe/Ljubljana',
		label: __('Europe/Ljubljana', 'better-chat-support'),
	},
	{
		value: 'Europe/London',
		label: __('Europe/London', 'better-chat-support'),
	},
	{
		value: 'Europe/Luxembourg',
		label: __('Europe/Luxembourg', 'better-chat-support'),
	},
	{
		value: 'Europe/Madrid',
		label: __('Europe/Madrid', 'better-chat-support'),
	},
	{
		value: 'Europe/Malta',
		label: __('Europe/Malta', 'better-chat-support'),
	},
	{
		value: 'Europe/Mariehamn',
		label: __('Europe/Mariehamn', 'better-chat-support'),
	},
	{
		value: 'Europe/Minsk',
		label: __('Europe/Minsk', 'better-chat-support'),
	},
	{
		value: 'Europe/Monaco',
		label: __('Europe/Monaco', 'better-chat-support'),
	},
	{
		value: 'Europe/Moscow',
		label: __('Europe/Moscow', 'better-chat-support'),
	},
	{
		value: 'Europe/Nicosia',
		label: __('Europe/Nicosia', 'better-chat-support'),
	},
	{
		value: 'Europe/Oslo',
		label: __('Europe/Oslo', 'better-chat-support'),
	},
	{
		value: 'Europe/Paris',
		label: __('Europe/Paris', 'better-chat-support'),
	},
	{
		value: 'Europe/Podgorica',
		label: __('Europe/Podgorica', 'better-chat-support'),
	},
	{
		value: 'Europe/Prague',
		label: __('Europe/Prague', 'better-chat-support'),
	},
	{
		value: 'Europe/Riga',
		label: __('Europe/Riga', 'better-chat-support'),
	},
	{
		value: 'Europe/Rome',
		label: __('Europe/Rome', 'better-chat-support'),
	},
	{
		value: 'Europe/Samara',
		label: __('Europe/Samara', 'better-chat-support'),
	},
	{
		value: 'Europe/San_Marino',
		label: __('Europe/San_Marino', 'better-chat-support'),
	},
	{
		value: 'Europe/Sarajevo',
		label: __('Europe/Sarajevo', 'better-chat-support'),
	},
	{
		value: 'Europe/Saratov',
		label: __('Europe/Saratov', 'better-chat-support'),
	},
	{
		value: 'Europe/Simferopol',
		label: __('Europe/Simferopol', 'better-chat-support'),
	},
	{
		value: 'Europe/Skopje',
		label: __('Europe/Skopje', 'better-chat-support'),
	},
	{
		value: 'Europe/Sofia',
		label: __('Europe/Sofia', 'better-chat-support'),
	},
	{
		value: 'Europe/Stockholm',
		label: __('Europe/Stockholm', 'better-chat-support'),
	},
	{
		value: 'Europe/Tallinn',
		label: __('Europe/Tallinn', 'better-chat-support'),
	},
	{
		value: 'Europe/Tirane',
		label: __('Europe/Tirane', 'better-chat-support'),
	},
	{
		value: 'Europe/Tiraspol',
		label: __('Europe/Tiraspol', 'better-chat-support'),
	},
	{
		value: 'Europe/Ulyanovsk',
		label: __('Europe/Ulyanovsk', 'better-chat-support'),
	},
	{
		value: 'Europe/Uzhgorod',
		label: __('Europe/Uzhgorod', 'better-chat-support'),
	},
	{
		value: 'Europe/Vaduz',
		label: __('Europe/Vaduz', 'better-chat-support'),
	},
	{
		value: 'Europe/Vatican',
		label: __('Europe/Vatican', 'better-chat-support'),
	},
	{
		value: 'Europe/Vienna',
		label: __('Europe/Vienna', 'better-chat-support'),
	},
	{
		value: 'Europe/Vilnius',
		label: __('Europe/Vilnius', 'better-chat-support'),
	},
	{
		value: 'Europe/Volgograd',
		label: __('Europe/Volgograd', 'better-chat-support'),
	},
	{
		value: 'Europe/Warsaw',
		label: __('Europe/Warsaw', 'better-chat-support'),
	},
	{
		value: 'Europe/Zagreb',
		label: __('Europe/Zagreb', 'better-chat-support'),
	},
	{
		value: 'Europe/Zaporozhye',
		label: __('Europe/Zaporozhye', 'better-chat-support'),
	},
	{
		value: 'Europe/Zurich',
		label: __('Europe/Zurich', 'better-chat-support'),
	},
	{
		value: 'GB',
		label: __('GB', 'better-chat-support'),
	},
	{
		value: 'GB-Eire',
		label: __('GB-Eire', 'better-chat-support'),
	},
	{
		value: 'GMT',
		label: __('GMT', 'better-chat-support'),
	},
	{
		value: 'GMT+0',
		label: __('GMT+0', 'better-chat-support'),
	},
	{
		value: 'GMT-0',
		label: __('GMT-0', 'better-chat-support'),
	},
	{
		value: 'GMT0',
		label: __('GMT0', 'better-chat-support'),
	},
	{
		value: 'Greenwich',
		label: __('Greenwich', 'better-chat-support'),
	},
	{
		value: 'HST',
		label: __('HST', 'better-chat-support'),
	},
	{
		value: 'Hongkong',
		label: __('Hongkong', 'better-chat-support'),
	},
	{
		value: 'Iceland',
		label: __('Iceland', 'better-chat-support'),
	},
	{
		value: 'Indian/Antananarivo',
		label: __('Indian/Antananarivo', 'better-chat-support'),
	},
	{
		value: 'Indian/Chagos',
		label: __('Indian/Chagos', 'better-chat-support'),
	},
	{
		value: 'Indian/Christmas',
		label: __('Indian/Christmas', 'better-chat-support'),
	},
	{
		value: 'Indian/Cocos',
		label: __('Indian/Cocos', 'better-chat-support'),
	},
	{
		value: 'Indian/Comoro',
		label: __('Indian/Comoro', 'better-chat-support'),
	},
	{
		value: 'Indian/Kerguelen',
		label: __('Indian/Kerguelen', 'better-chat-support'),
	},
	{
		value: 'Indian/Mahe',
		label: __('Indian/Mahe', 'better-chat-support'),
	},
	{
		value: 'Indian/Maldives',
		label: __('Indian/Maldives', 'better-chat-support'),
	},
	{
		value: 'Indian/Mauritius',
		label: __('Indian/Mauritius', 'better-chat-support'),
	},
	{
		value: 'Indian/Mayotte',
		label: __('Indian/Mayotte', 'better-chat-support'),
	},
	{
		value: 'Indian/Reunion',
		label: __('Indian/Reunion', 'better-chat-support'),
	},
	{
		value: 'Iran',
		label: __('Iran', 'better-chat-support'),
	},
	{
		value: 'Israel',
		label: __('Israel', 'better-chat-support'),
	},
	{
		value: 'Jamaica',
		label: __('Jamaica', 'better-chat-support'),
	},
	{
		value: 'Japan',
		label: __('Japan', 'better-chat-support'),
	},
	{
		value: 'Kwajalein',
		label: __('Kwajalein', 'better-chat-support'),
	},
	{
		value: 'Libya',
		label: __('Libya', 'better-chat-support'),
	},
	{
		value: 'MET',
		label: __('MET', 'better-chat-support'),
	},
	{
		value: 'MST',
		label: __('MST', 'better-chat-support'),
	},
	{
		value: 'MST7MDT',
		label: __('MST7MDT', 'better-chat-support'),
	},
	{
		value: 'Mexico/BajaNorte',
		label: __('Mexico/BajaNorte', 'better-chat-support'),
	},
	{
		value: 'Mexico/BajaSur',
		label: __('Mexico/BajaSur', 'better-chat-support'),
	},
	{
		value: 'Mexico/General',
		label: __('Mexico/General', 'better-chat-support'),
	},
	{
		value: 'NZ',
		label: __('NZ', 'better-chat-support'),
	},
	{
		value: 'NZ-CHAT',
		label: __('NZ-CHAT', 'better-chat-support'),
	},
	{
		value: 'Navajo',
		label: __('Navajo', 'better-chat-support'),
	},
	{
		value: 'PRC',
		label: __('PRC', 'better-chat-support'),
	},
	{
		value: 'PST8PDT',
		label: __('PST8PDT', 'better-chat-support'),
	},
	{
		value: 'Pacific/Apia',
		label: __('Pacific/Apia', 'better-chat-support'),
	},
	{
		value: 'Pacific/Auckland',
		label: __('Pacific/Auckland', 'better-chat-support'),
	},
	{
		value: 'Pacific/Bougainville',
		label: __('Pacific/Bougainville', 'better-chat-support'),
	},
	{
		value: 'Pacific/Chatham',
		label: __('Pacific/Chatham', 'better-chat-support'),
	},
	{
		value: 'Pacific/Chuuk',
		label: __('Pacific/Chuuk', 'better-chat-support'),
	},
	{
		value: 'Pacific/Easter',
		label: __('Pacific/Easter', 'better-chat-support'),
	},
	{
		value: 'Pacific/Efate',
		label: __('Pacific/Efate', 'better-chat-support'),
	},
	{
		value: 'Pacific/Enderbury',
		label: __('Pacific/Enderbury', 'better-chat-support'),
	},
	{
		value: 'Pacific/Fakaofo',
		label: __('Pacific/Fakaofo', 'better-chat-support'),
	},
	{
		value: 'Pacific/Fiji',
		label: __('Pacific/Fiji', 'better-chat-support'),
	},
	{
		value: 'Pacific/Funafuti',
		label: __('Pacific/Funafuti', 'better-chat-support'),
	},
	{
		value: 'Pacific/Galapagos',
		label: __('Pacific/Galapagos', 'better-chat-support'),
	},
	{
		value: 'Pacific/Gambier',
		label: __('Pacific/Gambier', 'better-chat-support'),
	},
	{
		value: 'Pacific/Guadalcanal',
		label: __('Pacific/Guadalcanal', 'better-chat-support'),
	},
	{
		value: 'Pacific/Guam',
		label: __('Pacific/Guam', 'better-chat-support'),
	},
	{
		value: 'Pacific/Honolulu',
		label: __('Pacific/Honolulu', 'better-chat-support'),
	},
	{
		value: 'Pacific/Johnston',
		label: __('Pacific/Johnston', 'better-chat-support'),
	},
	{
		value: 'Pacific/Kiritimati',
		label: __('Pacific/Kiritimati', 'better-chat-support'),
	},
	{
		value: 'Pacific/Kosrae',
		label: __('Pacific/Kosrae', 'better-chat-support'),
	},
	{
		value: 'Pacific/Kwajalein',
		label: __('Pacific/Kwajalein', 'better-chat-support'),
	},
	{
		value: 'Pacific/Majuro',
		label: __('Pacific/Majuro', 'better-chat-support'),
	},
	{
		value: 'Pacific/Marquesas',
		label: __('Pacific/Marquesas', 'better-chat-support'),
	},
	{
		value: 'Pacific/Midway',
		label: __('Pacific/Midway', 'better-chat-support'),
	},
	{
		value: 'Pacific/Nauru',
		label: __('Pacific/Nauru', 'better-chat-support'),
	},
	{
		value: 'Pacific/Niue',
		label: __('Pacific/Niue', 'better-chat-support'),
	},
	{
		value: 'Pacific/Norfolk',
		label: __('Pacific/Norfolk', 'better-chat-support'),
	},
	{
		value: 'Pacific/Noumea',
		label: __('Pacific/Noumea', 'better-chat-support'),
	},
	{
		value: 'Pacific/Pago_Pago',
		label: __('Pacific/Pago_Pago', 'better-chat-support'),
	},
	{
		value: 'Pacific/Palau',
		label: __('Pacific/Palau', 'better-chat-support'),
	},
	{
		value: 'Pacific/Pitcairn',
		label: __('Pacific/Pitcairn', 'better-chat-support'),
	},
	{
		value: 'Pacific/Pohnpei',
		label: __('Pacific/Pohnpei', 'better-chat-support'),
	},
	{
		value: 'Pacific/Ponape',
		label: __('Pacific/Ponape', 'better-chat-support'),
	},
	{
		value: 'Pacific/Port_Moresby',
		label: __('Pacific/Port_Moresby', 'better-chat-support'),
	},
	{
		value: 'Pacific/Rarotonga',
		label: __('Pacific/Rarotonga', 'better-chat-support'),
	},
	{
		value: 'Pacific/Saipan',
		label: __('Pacific/Saipan', 'better-chat-support'),
	},
	{
		value: 'Pacific/Samoa',
		label: __('Pacific/Samoa', 'better-chat-support'),
	},
	{
		value: 'Pacific/Tahiti',
		label: __('Pacific/Tahiti', 'better-chat-support'),
	},
	{
		value: 'Pacific/Tarawa',
		label: __('Pacific/Tarawa', 'better-chat-support'),
	},
	{
		value: 'Pacific/Tongatapu',
		label: __('Pacific/Tongatapu', 'better-chat-support'),
	},
	{
		value: 'Pacific/Truk',
		label: __('Pacific/Truk', 'better-chat-support'),
	},
	{
		value: 'Pacific/Wake',
		label: __('Pacific/Wake', 'better-chat-support'),
	},
	{
		value: 'Pacific/Wallis',
		label: __('Pacific/Wallis', 'better-chat-support'),
	},
	{
		value: 'Pacific/Yap',
		label: __('Pacific/Yap', 'better-chat-support'),
	},
	{
		value: 'Poland',
		label: __('Poland', 'better-chat-support'),
	},
	{
		value: 'Portugal',
		label: __('Portugal', 'better-chat-support'),
	},
	{
		value: 'ROC',
		label: __('ROC', 'better-chat-support'),
	},
	{
		value: 'ROK',
		label: __('ROK', 'better-chat-support'),
	},
	{
		value: 'Singapore',
		label: __('Singapore', 'better-chat-support'),
	},
	{
		value: 'Turkey',
		label: __('Turkey', 'better-chat-support'),
	},
	{
		value: 'UCT',
		label: __('UCT', 'better-chat-support'),
	},
	{
		value: 'US/Alaska',
		label: __('US/Alaska', 'better-chat-support'),
	},
	{
		value: 'US/Aleutian',
		label: __('US/Aleutian', 'better-chat-support'),
	},
	{
		value: 'US/Arizona',
		label: __('US/Arizona', 'better-chat-support'),
	},
	{
		value: 'US/Central',
		label: __('US/Central', 'better-chat-support'),
	},
	{
		value: 'US/East-Indiana',
		label: __('US/East-Indiana', 'better-chat-support'),
	},
	{
		value: 'US/Eastern',
		label: __('US/Eastern', 'better-chat-support'),
	},
	{
		value: 'US/Hawaii',
		label: __('US/Hawaii', 'better-chat-support'),
	},
	{
		value: 'US/Indiana-Starke',
		label: __('US/Indiana-Starke', 'better-chat-support'),
	},
	{
		value: 'US/Michigan',
		label: __('US/Michigan', 'better-chat-support'),
	},
	{
		value: 'US/Mountain',
		label: __('US/Mountain', 'better-chat-support'),
	},
	{
		value: 'US/Pacific',
		label: __('US/Pacific', 'better-chat-support'),
	},
	{
		value: 'US/Pacific-New',
		label: __('US/Pacific-New', 'better-chat-support'),
	},
	{
		value: 'US/Samoa',
		label: __('US/Samoa', 'better-chat-support'),
	},
	{
		value: 'UTC',
		label: __('UTC', 'better-chat-support'),
	},
	{
		value: 'Universal',
		label: __('Universal', 'better-chat-support'),
	},
	{
		value: 'W-SU',
		label: __('W-SU', 'better-chat-support'),
	},
	{
		value: 'WET',
		label: __('WET', 'better-chat-support'),
	},
	{
		value: 'Zulu',
		label: __('Zulu', 'better-chat-support'),
	},
];

export default function Edit(props) {
	const { attributes, setAttributes } = props;

	const {
		buttonSize,
		buttonType,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		iconTarget,
		background,
		iconBackground,
		visibility,
		buttonLinkTarget,
		messengerUserName,
		imageUrl,
		timeZone,
		mondayStart,
		mondayEnd,
		tuesdayStart,
		tuesdayEnd,
		wednesdayStart,
		wednesdayEnd,
		thursdayStart,
		thursdayEnd,
		fridayStart,
		fridayEnd,
		saturdayStart,
		saturdayEnd,
		sundayStart,
		sundayEnd,
		borderRadius,
		icon_borderRadius,
		buttonPadding,
		buttonBorder,
		buttonIconBorder,
		bgColor,
		bgHoverColor,
		textColor,
		textHoverColor,
		iconColor,
		iconHoverColor,
		iconBgColor,
		iconBgHoverColor,
	} = attributes;

	const [filteredOptions, setFilteredOptions] = useState(timezones);

	function onInputChange(value) {
		setFilteredOptions(
			timezones.filter((timezone) =>
				timezone.label.toLowerCase().includes(value.toLowerCase())
			)
		);
	}

	function onFontSizeChange(value) {
		setAttributes({ timeZone: value });
	}
	const onSelectImage = (image) => {
		setAttributes({
			imageUrl: image.url,
		});
	};
	const onChangeAlignment = (newAlignment) => {
		setAttributes({ textAlignment: newAlignment });
	};
	const onChangeText = (newText) => {
		setAttributes({ text: newText });
	};
	const advancedBtnInfo = (newInfo) => {
		setAttributes({ info: newInfo });
	};
	const advancedBtnTitle = (newTitle) => {
		setAttributes({ title: newTitle });
	};
	const advancedBtnOnlineBadge = (newOnline) => {
		setAttributes({ online: newOnline });
	};
	const onIconTarget = (onIconTargets) => {
		setAttributes({ iconTarget: onIconTargets });
	};
	const onIconBackground = (onIconBackgrounds) => {
		setAttributes({ iconBackground: onIconBackgrounds });
	};
	const onButtonLinkTarget = (newLinkTarget) => {
		setAttributes({ buttonLinkTarget: newLinkTarget });
	};

	const textClasses = classnames(`mSupportButtons-align-${textAlignment}`);

	const basicBtn = classnames(`mSupport_button block_btn`);
	const classes = classnames(
		`mSupportButtons mSupport_button mSupport_button_advance block_btn`
	);

	const buttonSizeOptions = [
		{ value: '0.7', label: __('XS', 'better-chat-support') },
		{ value: '0.8', label: __('S', 'better-chat-support') },
		{ value: '1', label: __('M', 'better-chat-support') },
		{ value: '1.2', label: __('L', 'better-chat-support') },
		{ value: '1.4', label: __('XL', 'better-chat-support') },
		{ value: '1.6', label: __('XXL', 'better-chat-support') },
	];
	const buttonTypeOptions = [
		{ value: 'basic-button', label: __('Basic Button', 'better-chat-support') },
		{
			value: 'advance-button',
			label: __('Advance Button', 'better-chat-support'),
		},
	];
	const visibilityOn = [
		{ value: '', label: __('Everywhere', 'better-chat-support') },
		{
			value: 'desktop',
			label: __('Desktop only', 'better-chat-support'),
		},
		{
			value: 'tablet',
			label: __('Tablets only', 'better-chat-support'),
		},
		{
			value: 'mobile',
			label: __('Mobile and tablets', 'better-chat-support'),
		},
		{
			value: 'mSupport-mobile-only',
			label: __('Mobile only', 'better-chat-support'),
		},
	];

	const [values, setValues] = useState({
		top: '5px',
		left: '15px',
		bottom: '5px',
		right: '15px',
	});

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<SelectControl
						label={__('Button Type', 'better-chat-support')}
						value={buttonType}
						options={buttonTypeOptions}
						onChange={(newButton) =>
							setAttributes({ buttonType: newButton })
						}
					/>

					<TextControl
						label={__('Messenger User Name', 'better-chat-support')}
						value={messengerUserName}
						onChange={(val) =>
							setAttributes({ messengerUserName: val })
						}
						help={__('Add your messanger user name.', 'better-chat-support')}
					/>
				</PanelBody>
			</InspectorControls>
			<InspectorControls>
				<PanelBody
					title={__('General Settings', 'better-chat-support')}
					initialOpen={false}
				>
					{buttonType === 'advance-button' ? (
						<>
							<MediaUpload
								label={__('Agent Image', 'better-chat-support')}
								onSelect={onSelectImage}
								allowedTypes={['image']}
								render={({ open }) => (
									<Button
										onClick={open}
										style={{
											marginBottom: '20px',
											fontSize: '16px',
										}}
									>
										<span
											style={{ marginRight: '5px' }}
											className="dashicons dashicons-format-status"
										></span>{' '}
										Agent photo
									</Button>
								)}
							/>
							<TextControl
								label={__('Agent Info', 'better-chat-support')}
								value={info}
								onChange={(val) => setAttributes({ info: val })}
								help={__(
									'Write agent name & agent title',
									'better-chat-support'
								)}
							/>
							<TextControl
								label={__('Button Label', 'better-chat-support')}
								value={title}
								onChange={(val) =>
									setAttributes({ title: val })
								}
								help={__(
									'Add custom button label',
									'better-chat-support'
								)}
							/>
							<TextControl
								label={__('Online Badge Text', 'better-chat-support')}
								value={online}
								onChange={(val) =>
									setAttributes({ online: val })
								}
								help={__(
									'Add custom badget text when user in online.',
									'better-chat-support'
								)}
							/>
							<TextControl
								label={__(
									'Offline Badge Text',
									'better-chat-support'
								)}
								value={offline}
								onChange={(val) =>
									setAttributes({ offline: val })
								}
								help={__(
									'Add custom badget text when user in offline.',
									'better-chat-support'
								)}
							/>
						</>
					) : (
						<TextControl
							label={__('Button Text', 'better-chat-support')}
							value={text}
							onChange={(val) => setAttributes({ text: val })}
						/>
					)}
					<ToggleControl
						label={__('Open link in new window', 'better-chat-support')}
						checked={buttonLinkTarget}
						onChange={onButtonLinkTarget}
					/>
				</PanelBody>
				<PanelBody
					title={__('Chat Settings', 'better-chat-support')}
					initialOpen={false}
				>
					<ComboboxControl
						label={__('Timezone', 'better-chat-support')}
						value={timeZone}
						options={filteredOptions}
						onChange={onFontSizeChange}
						onInputChange={onInputChange}
						help={__(
							'When using the date and time from the user browser you can transform it to your current timezone (in case your user is in a different timezone)',
							'better-chat-support'
						)}
					/>
					<PanelBody
						title={__('Monday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={mondayStart}
							onChange={(val) =>
								setAttributes({ mondayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={mondayEnd}
							onChange={(val) =>
								setAttributes({ mondayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Tuesday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={tuesdayStart}
							onChange={(val) =>
								setAttributes({ tuesdayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={tuesdayEnd}
							onChange={(val) =>
								setAttributes({ tuesdayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Wednesday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={wednesdayStart}
							onChange={(val) =>
								setAttributes({ wednesdayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={wednesdayEnd}
							onChange={(val) =>
								setAttributes({ wednesdayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Thursday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={thursdayStart}
							onChange={(val) =>
								setAttributes({ thursdayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={thursdayEnd}
							onChange={(val) =>
								setAttributes({ thursdayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Friday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={fridayStart}
							onChange={(val) =>
								setAttributes({ fridayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={fridayEnd}
							onChange={(val) =>
								setAttributes({ fridayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Saturday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={saturdayStart}
							onChange={(val) =>
								setAttributes({ saturdayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={saturdayEnd}
							onChange={(val) =>
								setAttributes({ saturdayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
					<PanelBody
						title={__('Sunday', 'better-chat-support')}
						initialOpen={false}
					>
						<TextControl
							label={__('Start Time', 'better-chat-support')}
							value={sundayStart}
							onChange={(val) =>
								setAttributes({ sundayStart: val })
							}
							placeholder={__('00:00', 'better-chat-support')}
						/>
						<TextControl
							label={__('End Time', 'better-chat-support')}
							value={sundayEnd}
							onChange={(val) =>
								setAttributes({ sundayEnd: val })
							}
							placeholder={__('24:00', 'better-chat-support')}
						/>
					</PanelBody>
				</PanelBody>
				<PanelBody
					title={__('Button Style', 'better-chat-support')}
					initialOpen={false}
				>
					<SelectControl
						label={__('Visibility on', 'better-chat-support')}
						value={visibility}
						options={visibilityOn}
						onChange={(newSize) =>
							setAttributes({ visibility: newSize })
						}
					/>
					<SelectControl
						label={__('Button Size', 'better-chat-support')}
						value={buttonSize}
						options={buttonSizeOptions}
						onChange={(newSize) =>
							setAttributes({ buttonSize: newSize })
						}
					/>
					<Spacer>
						<RangeControl
							label={__('Border Radius', 'better-chat-support')}
							value={borderRadius}
							onChange={(paddings) => {
								setAttributes({ borderRadius: paddings });
							}}
							min={5}
							max={100}
						/>
					</Spacer>
					<Spacer>
						<SelectControl
							label={__('Button Size', 'better-chat-support')}
							value={buttonSize}
							options={buttonSizeOptions}
							onChange={(newSize) =>
								setAttributes({ buttonSize: newSize })
							}
						/>
					</Spacer>
					<Spacer>
						<BoxControl
							label={__('Padding', 'better-chat-support')}
							values={buttonPadding}
							onChange={(newPadding) =>
								setAttributes({ buttonPadding: newPadding })
							}
							allowReset={false}
						/>
					</Spacer>
					<Spacer>
						<BorderBoxControl
							label={__('Border', 'better-chat-support')}
							value={buttonBorder}
							onChange={(newBorder) =>
								setAttributes({ buttonBorder: newBorder })
							}
							enableAlpha
							enableStyle
							shouldSanitizeBorder
							withSlider
							min={0}
							max={100}
						/>
					</Spacer>
					<Spacer>
						<BorderBoxControl
							label={__('Icon Border', 'better-chat-support')}
							value={buttonIconBorder}
							onChange={(newIconBorder) =>
								setAttributes({
									buttonIconBorder: newIconBorder,
								})
							}
							enableAlpha
							enableStyle
							shouldSanitizeBorder
							withSlider
							min={0}
							max={100}
						/>
					</Spacer>
					<Spacer>
						<RangeControl
							label={__('Icon Border Radius', 'better-chat-support')}
							value={icon_borderRadius}
							onChange={(borderRadius) => {
								setAttributes({
									icon_borderRadius: borderRadius,
								});
							}}
							min={5}
							max={100}
						/>
					</Spacer>
					<Spacer>
						<PanelColorSettings
							title={__('Background Colors', 'better-chat-support')}
							colorSettings={[
								{
									label: __(
										'Normal Background',
										'better-chat-support'
									),
									value: bgColor,
									onChange: (color) =>
										setAttributes({ bgColor: color }),
								},
								{
									label: __(
										'Hover Background',
										'better-chat-support'
									),
									value: bgHoverColor,
									onChange: (color) =>
										setAttributes({ bgHoverColor: color }),
								},
							]}
						/>
					</Spacer>
					<Spacer>
						<PanelColorSettings
							title={__('Text Colors', 'better-chat-support')}
							colorSettings={[
								{
									label: __('Normal Color', 'better-chat-support'),
									value: textColor,
									onChange: (color) =>
										setAttributes({ textColor: color }),
								},
								{
									label: __('Hover Color', 'better-chat-support'),
									value: textHoverColor,
									onChange: (color) =>
										setAttributes({
											textHoverColor: color,
										}),
								},
							]}
						/>
					</Spacer>
				</PanelBody>
			</InspectorControls>
			{buttonType === 'basic-button' && (
				<InspectorControls>
					<PanelBody
						title={__('Icon', 'better-chat-support')}
						initialOpen={false}
					>
						<ToggleControl
							label={__('Add Icon', 'better-chat-support')}
							checked={iconTarget}
							onChange={onIconTarget}
						/>
						{iconTarget && (
							<>
								<Spacer>
									<PanelColorSettings
										title={__(
											'Icon Color',
											'better-chat-support'
										)}
										colorSettings={[
											{
												label: __(
													'Normal Color',
													'better-chat-support'
												),
												value: iconColor,
												onChange: (color) =>
													setAttributes({
														iconColor: color,
													}),
											},
											{
												label: __(
													'Hover Color',
													'better-chat-support'
												),
												value: iconHoverColor,
												onChange: (color) =>
													setAttributes({
														iconHoverColor: color,
													}),
											},
										]}
									/>
								</Spacer>
								<ToggleControl
									label={__(
										'Icon Background',
										'better-chat-support'
									)}
									checked={iconBackground}
									onChange={onIconBackground}
								/>
								{iconBackground && (
									<Spacer>
										<PanelColorSettings
											title={__(
												'Icon Background Color',
												'better-chat-support'
											)}
											colorSettings={[
												{
													label: __(
														'Normal Color',
														'better-chat-support'
													),
													value: iconBgColor,
													onChange: (color) =>
														setAttributes({
															iconBgColor: color,
														}),
												},
												{
													label: __(
														'Hover Color',
														'better-chat-support'
													),
													value: iconBgHoverColor,
													onChange: (color) =>
														setAttributes({
															iconBgHoverColor:
																color,
														}),
												},
											]}
										/>
									</Spacer>
								)}
							</>
						)}
					</PanelBody>
				</InspectorControls>
			)}
			<BlockControls>
				<AlignmentToolbar
					value={textAlignment}
					onChange={onChangeAlignment}
				/>
			</BlockControls>
			{buttonType === 'basic-button' ? (
				<div className={`button-wrapper mSupport-editor ${textClasses}`}>
					<a
						{...useBlockProps({
							className: `${basicBtn} ${visibility}`,
						})}
						style={{
							'--mSupport-padding': `${buttonPadding.top} ${buttonPadding.right} ${buttonPadding.bottom} ${buttonPadding.left}`,
							'--mSupport-btn-scale': `${buttonSize}`,
							'--mSupport-border-radius': `${borderRadius}px`,
							'--mSupport-border': `${buttonBorder?.width} ${buttonBorder?.style} ${buttonBorder?.color}`,
							'--mSupport-icon-border': `${buttonIconBorder?.width} ${buttonIconBorder?.style} ${buttonIconBorder?.color}`,
							'--mSupport-icon-border-radius': `${icon_borderRadius}px`,
							'--mSupport-background': `${bgColor}`,
							'--mSupport-hover-background': `${bgHoverColor}`,
							'--mSupport-text-color': `${textColor}`,
							'--mSupport-text-hover-color': `${textHoverColor}`,
							'--mSupport-icon-normal-color': `${iconColor}`,
							'--mSupport-icon-hover-color': `${iconHoverColor}`,
							'--mSupport-icon-normal-bg-color': `${iconBgColor}`,
							'--mSupport-icon-hover-bg-color': `${iconBgHoverColor}`,
						}}
					>
						{iconTarget && (
							<div
								className={`bubble__icon ${iconBackground === true ? 'icon_bg' : ''}`}
							>
								<span className="dashicons dashicons-format-status"></span>
							</div>
						)}
						<RichText
							onChange={onChangeText}
							value={text}
							placeholder={__(
								'How can I help you?',
								'better-chat-support'
							)}
							tagName="span"
							allowedFormats={[]}
						/>
					</a>
				</div>
			) : (
				<div className={`button-wrapper mSupport-editor ${textClasses}`}>
					<div
						{...useBlockProps({
							className: `avatar-active ${classes} ${visibility}`,
						})}
						style={{
							'--mSupport-padding': `${buttonPadding.top} ${buttonPadding.right} ${buttonPadding.bottom} ${buttonPadding.left}`,
							'--mSupport-btn-scale': `${buttonSize}`,
							'--mSupport-border-radius': `${borderRadius}px`,
							'--mSupport-border': `${buttonBorder?.width} ${buttonBorder?.style} ${buttonBorder?.color}`,
							'--mSupport-icon-border': `${buttonIconBorder?.width} ${buttonIconBorder?.style} ${buttonIconBorder?.color}`,
							'--mSupport-icon-border-radius': `${icon_borderRadius}px`,
							'--mSupport-background': `${bgColor}`,
							'--mSupport-hover-background': `${bgHoverColor}`,
							'--mSupport-text-color': `${textColor}`,
							'--mSupport-text-hover-color': `${textHoverColor}`,
						}}
						data-btnavailability={`{ "monday":"${mondayStart}-${mondayEnd}", "tuesday":"${tuesdayStart}-${tuesdayEnd}", "wednesday":"${wednesdayStart}-${wednesdayEnd}", "thursday":"${thursdayStart}-${thursdayEnd}", "friday":"${fridayStart}-${fridayEnd}", "saturday":"${saturdayStart}-${saturdayEnd}", "sunday":"${sundayStart}-${sundayEnd}" }`}
						data-timezone={timeZone}
					>
						<img
							src={imageUrl ? imageUrl : agentImage}
							alt="agent"
						/>
						<div className="info-wrapper">
							<RichText
								onChange={advancedBtnInfo}
								value={info}
								placeholder={__(
									'Robert / Sales Support',
									'better-chat-support'
								)}
								tagName="div"
								allowedFormats={[]}
								className="info"
							/>
							<RichText
								onChange={advancedBtnTitle}
								value={title}
								placeholder={__(
									'How can I help you?',
									'better-chat-support'
								)}
								tagName="div"
								allowedFormats={[]}
								className="mSupport_title"
							/>
							<RichText
								onChange={advancedBtnOnlineBadge}
								value={online}
								placeholder={__('I am online', 'better-chat-support')}
								tagName="div"
								allowedFormats={[]}
								className="online"
							/>
							<RichText
								onChange={advancedBtnOnlineBadge}
								value={offline}
								placeholder={__(
									"I'm not available",
									'better-chat-support'
								)}
								tagName="div"
								allowedFormats={[]}
								className="offline"
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
